<template>

    <b-container style="flex: available">
        <b-container>
            <span style="margin-top: 10px"><br/></span>
            <b-container fluid>
                <b-container fluid>
                    <b-card bg-variant="light">

                        <b-form-group
                                label-cols-sm="4"
                                label="Business Name*:"
                                label-align-sm="left"
                                label-for="nested-street"
                        >
                            <b-form-input id="nested-company-name" size="sm" v-model="businessName"
                                          placeholder="Business Name"></b-form-input>
                        </b-form-group>

                        <b-form-group
                                label-cols="4"
                                label-size="md"
                                label="Business Address*:"
                                label-align-sm="left"
                                label-for="nested-street"
                        >
                            <b-form-input id="nested-street" size="sm" v-model="businessAddress"
                                          placeholder="Business Address"></b-form-input>
                        </b-form-group>

                        <b-form-group
                                label-cols="4"
                                label-cols-lg="4"
                                label-size="md"
                                label="Contact Name*: (Someone familiar with the winery operation and facility)"
                                label-for="input-sm">
                            <b-form-input id="input-sm" size="sm" v-model="contactName"
                                          placeholder="Contact Name"></b-form-input>
                        </b-form-group>

                        <b-form-group
                                label-cols="4"
                                label-cols-lg="4"
                                label-size="md"
                                label="Contact Phone Number*:"
                                label-for="input-sm">
                            <b-form-input id="telephoneNumber" size="sm"
                                          v-model="contactTelephoneNumber" placeholder="Telephone"></b-form-input>
                        </b-form-group>

                        <b-form-group
                                label-cols="4"
                                label-cols-lg="4"
                                label-size="md"
                                label="Email Address*:"
                                label-for="input-sm">
                            <b-form-input id="input-sm" size="sm" v-model="contactEmail"
                                          placeholder="Contact Email"></b-form-input>
                        </b-form-group>

                        <b-form-group
                                label-cols="4"
                                label-cols-lg="4"
                                label-size="md"
                                label="Waste/Recycling/Compost Service Provider Name(s):"
                                label-for="input-sm">
                            <b-form-input id="input-sm" size="sm" v-model="wasteProvider"
                                          placeholder="Waste Provider"></b-form-input>
                        </b-form-group>
                        <b-form-group
                                label-cols="4"
                                label-cols-lg="4"
                                label-size="md"
                                label="Water Supply Source: (Well/Municipal)"
                                label-for="input-sm">
                            <b-form-input id="input-sm" size="sm" v-model="waterSupplySource"
                                          placeholder="Water Supply Source"></b-form-input>
                        </b-form-group>

                        <b-container fluid>

                            <b-form-group
                                    label="Do you have a water meter that allows you to track process + offices + hospitality water use? (If no, we can assist with this).">
                                <b-form-radio-group
                                        v-model="trackableWaterMeter"
                                        :options="yesNoOptions"
                                        name="waterMeterTracking"
                                        stacked
                                ></b-form-radio-group>
                            </b-form-group>


                            <b-form-group
                                    label="Have you had a PG&E/CLEAResult Wine Industry Efficiency Solutions (WIES) audit in the past 5 years?">
                                <b-form-radio-group
                                        v-model="wiesSelected"
                                        :options="yesNoOptions"
                                        name="clearResult   "
                                        stacked
                                ></b-form-radio-group>
                            </b-form-group>
                            <b-form-group label="Have you installed renewable energy?">
                                <b-form-radio-group
                                        v-model="renewableEnergy"
                                        :options="yesNoOptions"
                                        name="flavour-2a"
                                        stacked
                                ></b-form-radio-group>
                            </b-form-group>
                            <b-form-group label="Please indicate if you have the following features:">
                                <b-form-checkbox-group
                                        v-model="featuresSelected"
                                        :options="featuresOptions"
                                        name="flavour-2a"
                                        stacked
                                ></b-form-checkbox-group>
                            </b-form-group>
                            <b-form-group label="Wastewater Treatment (Check relevant): ">
                                <b-form-checkbox-group
                                        v-model="wasteWaterSelected"
                                        :options="wasteWaterTreatmentOptions"
                                        name="flavour-2a"
                                        stacked
                                ></b-form-checkbox-group>
                            </b-form-group>
                        </b-container>

                        <div class="button-holder">
                            <b-row align-h="center">
                                <b-col cols="2"></b-col>
                                <b-col cols="8">*Questions marked with an asterisk must be completed to submit the
                                    form.
                                </b-col>
                                <b-col cols="2"></b-col>
                            </b-row>
                        </div>

                        <div class="button-holder">
                            <b-row align-h="center">
                                <b-col cols="2">
                                    <b-button id="submitButton" style="color: white; background-color: green"
                                              class="submit-button"
                                              type="submit" @click="submit"
                                              variant="primary" :disabled="!canSubmit">Submit
                                    </b-button>
                                </b-col>
                                <b-col cols="2">
                                    <b-button style="color: white; background-color: green" class="cancel-button"
                                              type="cancel" @click="cancel"
                                              variant="primary">Cancel
                                    </b-button>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                </b-container>
            </b-container>
        </b-container>
    </b-container>


</template>
<script>

import swal from 'sweetalert';

const emailRegex = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;

    export default {
        data() {
            return {
                requiredText: "*Required",
                contactName: '',
                telephoneNumber: '',
                contactTelephoneNumber: '',
                contactEmail: '',
                businessName: '',
                businessAddress: '',
                wasteProvider: '',
                waterSupplySource: '',
                wiesSelected: '',
                trackableWaterMeter: '',
                onSiteBottling: '',
                renewableEnergy: '',
                yesNoOptions: ["Yes", "No"],
                featuresSelected: [],
                featuresOptions: ["Barrel cellar", "Caves", "On Site Bottling", "Winery Tasting Room", "Offsite Tasting Room"
                    , "Onsite Kitchen", "Barrel Cleaning Machine"],
                wasteWaterSelected: [],
                wasteWaterTreatmentOptions: ["Pond(s)", "Leach", "Packaged treatment system", "Hold and Haul"],
                isSubmitted: true
            }
        },
        computed: {
            validateBusinessName: function () {
                let isValid = this.businessName !== "Business Name" && this.businessName !== '';
                console.log("Business Name valid: " + isValid);
                return isValid;
            },
            validateBusinessAddress: function () {
                let isValid = this.businessAddress !== "Business Address" && this.businessAddress !== '';
                console.log("Business Name valid: " + isValid);
                return isValid;
            },
            validateContactName: function () {
                let isValid = this.contactName !== "Contact Name" && this.contactName !== '';
                console.log("Business Name valid: " + isValid);
                return isValid;
            },
            validateContactTelephoneNumber: function () {
                let isValid = this.contactTelephoneNumber !== "Telephone" && this.contactTelephoneNumber !== '';
                console.log("Business Name valid: " + isValid);
                return isValid;
            },
            validateContactEmail: function () {
                let isValid = this.validateEmailAddress(this.contactEmail);
                console.log("Email Address valid: " + isValid);
                return isValid;
            },
            canSubmit: function () {
                return this.validateContactEmail && this.validateContactTelephoneNumber
                    && this.validateContactName && this.validateBusinessAddress && this.validateBusinessName;
            }
        },

        methods: {
            cancel: function () {
                alert('cancel');
            },
            validateEmail: function (mail) {
                if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
                    return (true)
                }
                alert("You have entered an invalid email address!")
                return (false)
            },
            validateEmailAddress: function (email) {
                return emailRegex.test(String(email).toLowerCase());
            },
            isFieldValid: function (fieldValue, defaultValue) {
                console.log(Object.keys(fieldValue));
                return fieldValue !== defaultValue && fieldValue !== "";
            }, validateForm: function (self, data) {
                return self.validateEmailAddress(data.contactEmail)
                    && self.isFieldValid(data.contactName, "Contact Name")
                    && self.isFieldValid(data.contactTelephoneNumber, "Telephone")
                    && self.isFieldValid(data.contactEmail, "Contact Email")
                    && self.isFieldValid(data.businessName, "Business Name")
                    && self.isFieldValid(data.businessAddress, "Business Address");
            },
            buildValidationMessage: function () {
                return "Please enter a valid email address.";
            },
            submit: function () {
                event.target.disabled = true;
                let self = this;
                let data = {
                    contactName: this.contactName,
                    telephoneNumber: this.telephoneNumber,
                    contactTelephoneNumber: this.contactTelephoneNumber,
                    contactEmail: this.contactEmail,
                    businessName: this.businessName,
                    businessAddress: this.businessAddress,
                    wasteProvider: this.wasteProvider,
                    waterSupplySource: this.waterSupplySource,
                    wiesSelected: this.wiesSelected,
                    trackableWaterMeter: this.trackableWaterMeter,
                    onSiteBottling: this.onSiteBottling,
                    renewableEnergy: this.renewableEnergy,
                    featuresSelected: this.featuresSelected,
                    wasteWaterSelected: this.wasteWaterSelected,
                    status: 'PENDING'
                };
                swal("Your group information has been updated", "success");
                self.$http.post('account/request', data, {
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(function (response) {
                    console.log(response.data);
                    self.$router.push({path: '/account-requested'});
                })
                    .catch(function (error) {
                        console.log("Something went wrong: ", error);
                    });
            }
        }
    }
</script>
<style>
    .invalid-field {
        color: red;
        size: 14px;
        font-style: italic;
    }
</style>
